import { Store } from "@reduxjs/toolkit";
import { signIn } from "./slice";

import { AuthManager, AuthManagerSetupOptions } from "./AuthManager";

const authManager = AuthManager.getInstance();
let _store: Store | null = null;

export const setup = async (store: Store, options: AuthManagerSetupOptions) => {
  _store = store;
  return authManager.setup(store, options);
};

export const login = async (redirectUri?: string) => {
  return authManager.login(redirectUri);
};

export const logout = async (ignoreDispatch = false) => {
  return authManager.logout(ignoreDispatch);
};

export const getToken = async () => {
  return authManager.getToken();
};

export const getCurrentToken = () => {
  return authManager.getCurrentToken();
};

export const getKcClientId = () => {
  return authManager.getKcClientId();
};

export const updateSignInState = async () => {
  const dispatch = _store?.dispatch;
  if (!dispatch) throw new Error("Dispatch not found");
  dispatch(signIn());
};

export const isInternalAccount = () => {
  return authManager.isInternalAccount();
};

// Re-export AuthManager for direct access
export { AuthManager } from "./AuthManager";
